import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';
import CurrencyFormats from 'commons-vehicle/constants/currencyFormats.js';

import ReactCollapse from 'react-collapse';

class AmountLineItem extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showAccessoriesDetails: false,
        };

        this.showAccessoriesDetails = this.showAccessoriesDetails.bind(this);
    }
    showAccessoriesDetails() {
        this.setState((prevState) => {
            return { showAccessoriesDetails: !prevState.showAccessoriesDetails };
        });
    }
    render() {
        const { label, amount, separator, subItem } = this.props;
        const subClass = 'amountLineItem sub';
        const classes = separator
            ? 'SidebarSummary__listingAmount--item sr-text-regular amountLineItem'
            : 'sr-text-regular amountLineItem';
        return amount ? (
            <div>
                <li className={classes} onClick={subItem.length > 0 && this.showAccessoriesDetails}>
                    <span className="label">{label}</span>
                    <span className="value">
                        {LocaleService.l(amount, CurrencyFormats.CURRENCY_2)}
                        {subItem.length > 0 && (
                            <icon
                                className={
                                    this.state.showAccessoriesDetails
                                        ? 'icon-chevron-thin-down inverted'
                                        : 'icon-chevron-thin-down'
                                }
                            />
                        )}
                    </span>
                </li>
                {subItem.length > 0 && (
                    <ReactCollapse isOpened={this.state.showAccessoriesDetails}>
                        {subItem.map((item) => {
                            return item.amount ? (
                                <li className={subClass}>
                                    <span className="label">{item.description}</span>
                                    <span className="value">
                                        {LocaleService.l(item.amount, CurrencyFormats.CURRENCY_2)}
                                    </span>
                                </li>
                            ) : null;
                        })}
                    </ReactCollapse>
                )}
            </div>
        ) : null;
    }
}

AmountLineItem.defaultProps = {
    separator: false,
    subItem: [],
};

AmountLineItem.propTypes = {
    label: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
    separator: PropTypes.bool,
    // eslint-disable-next-line react/forbid-prop-types
    subItem: PropTypes.array,
};

AmountLineItem.displayName = 'AmountLineItem';

export default AmountLineItem;
